module.exports = __webpack_public_path__ + "static/img/oprCt_bg_04.08fde911.svg";